// extracted by mini-css-extract-plugin
export default {"navigation":"style_navigation__YSRYR","list":"style_list__AVvf2","item":"style_item__oaOt6","logout":"style_logout__eW-wL"};